import React, { PropsWithChildren, ReactElement } from 'react';

import { Accordion, Col, Grid, Panel, Row, Stack, Text } from 'rsuite';
import CheckIcon from '@rsuite/icons/CheckRound';
import './bucket-group-wrapper.css';

interface BucketGroupWrapperProps {
  collapsible?: boolean;
  isCompleted?: boolean;
  title: string;
}

export const BucketGroupWrapper = ({
  children,
  isCompleted,
  collapsible,
  title,
}: PropsWithChildren<BucketGroupWrapperProps>): ReactElement => {
  if (!collapsible) {
    return (
      <Panel
        className="bucket-group-wrapper-panel"
        bodyProps={{ style: { padding: '0px' } }}
        header={
          <Text
            size="m"
            as="h4"
            style={{ textAlign: 'left', margin: '0 -20px' }}
          >
            {title}
          </Text>
        }
      >
        {children}
      </Panel>
    );
  }

  const handleClick = (
    _: string | number | undefined,
    e: React.SyntheticEvent
  ) => {
    e.preventDefault();
  };
  return (
    <Accordion
      onSelect={handleClick}
      classPrefix="bucket-group-wrapper"
    >
      <Accordion.Panel
        header={
          <Grid>
            <Row>
              <Col xs={18}>
                <Text
                  size="md"
                  as="h5"
                  className="bucket-group-wrapper-title"
                >
                  {title}
                </Text>
              </Col>
              <Col xs={6}>
                <Text
                  align="right"
                  as="i"
                  size="sm"
                  className="bucket-group-wrapper-subtitle"
                >
                  {isCompleted ? (
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={1}
                    >
                      <CheckIcon
                        aria-hidden="true"
                        className="bucket-group-wrapper-completed-icon"
                        height={20}
                      />
                      <Text as="p">Reporting Complete</Text>
                    </Stack>
                  ) : (
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={1}
                    >
                      <Text as="p">Reporting Incomplete</Text>
                    </Stack>
                  )}
                </Text>
              </Col>
            </Row>
          </Grid>
        }
      >
        {children}
      </Accordion.Panel>
    </Accordion>
  );
};
